import { Component } from '@angular/core';

/**
 * Public hero landing — the app's front door at '/'.
 * Adapted (hero section only) from "LMS+ Front Page (latest local).html", dark
 * variant to match the sign-in reskin. Reuses the magnetic-grid canvas
 * (<app-login-grid-bg>) and the scoped --lms-* tokens. No auth logic here — the
 * route's GuestLandingGuard redirects logged-in users to the dashboard.
 */
@Component({
	selector: 'app-landing-hero',
	templateUrl: './landing-hero.component.html',
	styleUrls: ['./landing-hero.component.scss'],
	// Keep the literal spaces between the headline word <span>s — Angular's default
	// preserveWhitespaces:false strips them, jamming "We generate qualified leads".
	preserveWhitespaces: true,
})
export class LandingHeroComponent {
	// Sister portals live on their own subdomains — open in the same tab (per spec).
	readonly clientPortalUrl = 'https://app.lmsleads.com';
	readonly callerPortalUrl = 'https://caller.lmsleads.com';

	// TODO(booking-url): replace '#' with the real 15-min call booking link.
	readonly bookCallHref = '#';
	// TODO(booking-url): replace '#' with the real demo-request link.
	readonly requestDemoHref = '#';
}
